/* File to contain the MSAL configs to keep it out of app.module.ts */

import { environment } from "../../environments/environment";
import {
  IPublicClientApplication,
  PublicClientApplication,
  LogLevel,
  BrowserCacheLocation,
  InteractionType
} from "@azure/msal-browser";
import { MsalGuardConfiguration, MsalInterceptorConfiguration } from "@azure/msal-angular";

const scopeUserRead: string = "user.read";
const apiResource = (path: string): string => `${environment.apiUrl}/${path}`;
const applicationScopes: string[] = [
  ...environment.config.scopes,
  ...environment.config.apiScopes,
  ...environment.config.actionScope,
  ...environment.config.reasonScope,
  ...environment.config.stationsScope,
  ...environment.config.linenumberScope,
  ...environment.config.eventlogScope,
  ...environment.config.notificationScope,
  ...environment.config.trainScope
];

const protectedResourceMap: Map<string, Array<string>> = new Map<string, Array<string>>([
  [apiResource(environment.actionApi.path), environment.config.actionScope],
  [apiResource(environment.reasonApi.path), environment.config.reasonScope],
  [apiResource(environment.stationsApi.path), environment.config.stationsScope],
  [apiResource(environment.linenumberApi.path), environment.config.linenumberScope],
  [apiResource(environment.eventLogApi.path), environment.config.eventlogScope],
  [apiResource(environment.notificationApi.path), environment.config.notificationScope],
  [apiResource(environment.trainApi.path), environment.config.trainScope],
  ["https://graph.microsoft.com/v1.0/me", [scopeUserRead]],
  ["https://graph.microsoft.com/v1.0", [scopeUserRead]],
]);

const isIE =
  window.navigator.userAgent.indexOf("MSIE ") > -1 ||
  window.navigator.userAgent.indexOf("Trident/") > -1;

export function loggerCallback(logLevel: LogLevel, message: string) {
  console.log(message);
}

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.config.clientID,
      authority:
        "https://login.microsoftonline.com/" + environment.config.tenantID,
      redirectUri: environment.config.redirectUrl,
      postLogoutRedirectUri: `${environment.config.url}/signout-oidc`,
      navigateToLoginRequestUrl: true,
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: isIE, // set to true for IE 11
    },
    system: {
      loggerOptions: {
        loggerCallback,
        logLevel: LogLevel.Error,
        piiLoggingEnabled: false
      }
    }
  });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: applicationScopes
    }
  };
}
